import Component from "@glimmer/component"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"

interface Args {
  planbook: Planbook
  rotationCalendar: RotationCalendar
  dateString: string
}
export default class RoutineProviderComponent extends Component<Args> {}
